<script>
    import { createEventDispatcher, onMount, afterUpdate } from "svelte";
	import { fly } from "svelte/transition";
    import { form } from "svelte-forms";
    import { _ } from "svelte-i18n";

    import Field from "src/form/Field.svelte";
    import Checkbox from "src/form/Checkbox.svelte";

    import { contact } from "src/contact.store";

    const dispatch = new createEventDispatcher();

    let contactForm;
    onMount(() => {
        contactForm = form(() => ({
            name: { value: $contact.name, validators: ['required'] },
            surname: { value: $contact.surname, validators: ['required'] },
            company: { value: $contact.company, validators: ['required'] },
            email: { value: $contact.email, validators: ['required', 'email'] }
        }), { validateOnChange: false });
    });

    afterUpdate(() => {
        contactForm.validate();
    });
</script>

<div class="pc__contact" in:fly="{{ x: -200, duration: 500 }}">
    {#if contactForm}
    <Field
        variant="name"
        type="text"
        label={$_('contact.name')}
        bind:value={$contact.name} />
    <Field
        variant="surname"
        type="text"
        label={$_('contact.surname')}
        bind:value={$contact.surname} />
    <Field
        variant="company"
        type="text"
        label={$_('contact.company')}
        bind:value={$contact.company} />
    <Field
        variant="email"
        type="email"
        label={$_('contact.email')}
        bind:value={$contact.email} />
    <Checkbox
        label={$_('contact.privacy')}
        bind:checked={$contact.privacy} />
    <button type="button" class="pc__button pc__button--back" on:click={() => dispatch("routeEvent", "")}>{$_('contact.back')}</button>
    <button type="submit" class="pc__button pc__button--primary pc__button--contact" disabled={!$contactForm.valid || !$contact.privacy}>{$_('contact.submit')}</button>
    {/if}
</div>